import React, { Component, Fragment } from 'react'
import NumberFormat from 'react-number-format';
import {storedb} from "../client/storedb";
import orderConstants from "../Order/constants";
import AppConfig from "../../config/app";

export default class UiEditable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowCkEditabled: false,
      isShowCkCtr: false,
    }
  }
  showCtr = (value) => {
    this.setState({
      isShowCkEditabled: !value,
      isShowCkCtr: value
    })
  }
  toggleEditCk = (value) => {
    if (this.props.allowEditable) {
      this.setState({isShowCkEditabled: value})
    } else {
      this.setState({isShowCkEditabled: false})
    }
  }
  toggleKeyPress = (e) => {
    if (e.keyCode === 9 || e.keyCode === 13) {
      this.showCtr(false)
      this.toggleEditCk(false)
    }
  }
  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }
  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.showCtr(false)
      this.toggleEditCk(false)
    }
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  componentWillMount() {
    document.removeEventListener('mousedown', (e) => this.handleClickOutside(e));
  }
  componentDidMount(){
    document.addEventListener('mousedown', (e) => this.handleClickOutside(e));
  }
  render() {
    return (
      <div className={`p-0 m-0 ${this.props.classNameWarper}`}
        onMouseEnter={e => this.toggleEditCk(true)}
        onMouseLeave={e => this.toggleEditCk(false)}
        ref={this.setWrapperRef}
      >
        {!this.state.isShowCkCtr && (
          <Fragment>{this.props.valueStr}</Fragment>
        )}
        {this.state.isShowCkCtr && (
          <NumberFormat
            name={this.props.name}
            value={this.props.value}
            defaultValue={this.props.defaultValue}
            thousandSeparator={this.props.thousandSeparator}
            decimalSeparator={this.props.decimalSeparator}
            decimalScale={this.props.decimalScale}
            type={this.props.type}
            allowEmptyFormatting={this.props.allowEmptyFormatting}
            className={this.props.className}
            onClick={this.numberOnclick}
            onValueChange={this.props.onValueChange}
            onKeyDown={e => this.toggleKeyPress(e)}
          />
        )}
        {!this.state.isShowCkCtr && (
          <i
            onClick={e => this.showCtr(true)}
            className={`pointer fa fa-pencil ml-1 ${!this.state.isShowCkEditabled ? "d-none fadeOut" : "fadeIn"}`}>
          </i>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/MarketingOrder/_UiEditable.js